import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
import { MAIL_RECIPIENT_FROM } from '@/constant/system/code';
import { Plus } from '@element-plus/icons-vue';
import MailUserInfoDialog from './MailUserInfoDialog.vue';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'RecipientSelect',
  props: {
    placeholder: {
      default: '请选择'
    },
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const userInfoDialog = ref();
    const selectRows = ref([]);
    const mailContacts = ref([]);
    const options = computed(() => {
      const opt = [...selectRows.value, ...mailContacts.value];
      const defaultOption = [];
      if (props.modelValue) {
        props.modelValue.forEach(i => {
          const option = opt.find(o => o.id === i.id);
          if (!option) {
            defaultOption.push(i);
          }
        });
      }
      opt.push(...defaultOption);
      return opt;
    });
    const value = computed({
      get() {
        return props.modelValue?.map(i => i.id) || [];
      },
      set(newValue) {
        emits('update:modelValue', newValue);
      }
    });
    function select(rows) {
      selectRows.value = rows.tab1.map(i => ({
        id: i.id,
        key: `${i.id} + ${MAIL_RECIPIENT_FROM.SYSTEM_USER.CODE}`,
        mailAddress: i.email,
        recipientFrom: MAIL_RECIPIENT_FROM.SYSTEM_USER.CODE,
        recipientName: i.nickname
      }));
      mailContacts.value = rows.tab2.map(i => ({
        id: i.id,
        key: `${i.id} + ${MAIL_RECIPIENT_FROM.MAIL_RECIPIENT.CODE}`,
        mailAddress: i.mailAddress,
        recipientFrom: MAIL_RECIPIENT_FROM.MAIL_RECIPIENT.CODE,
        recipientName: i.recipientName
      }));
      emits('update:modelValue', [...selectRows.value, ...mailContacts.value]);
    }
    function selectUser() {
      userInfoDialog.value?.open();
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        placeholder: "Please input",
        class: "input-with-select"
      }, {
        prepend: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(value) ? value.value = $event : null),
          placeholder: _ctx.placeholder,
          style: {
            "width": "115px"
          },
          multiple: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.recipientName,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128)), _unref(options).length === 0 ? (_openBlock(), _createBlock(_component_el_option, {
            key: 0,
            label: "Tel",
            value: "3"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
              style: {
                "text-align": "center"
              }
            }, "点击右侧按钮+添加收件人", -1)])),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "placeholder"])]),
        append: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: selectUser,
          icon: _unref(Plus)
        }, null, 8, ["icon"])]),
        _: 1
      }), _createVNode(MailUserInfoDialog, {
        ref_key: "userInfoDialog",
        ref: userInfoDialog,
        onSelect: select,
        "default-select": _unref(value),
        "default-mail-contact": _unref(value)
      }, null, 8, ["default-select", "default-mail-contact"])]);
    };
  }
});